import React from "react"

const BuscarFacturaDesdeArticulos = () => {
  return <div>BuscarFacturaDesdeArticulos</div>
}

export default BuscarFacturaDesdeArticulos
